<script>
import Multiselect from "vue-multiselect";
import { appSectionsMethods } from "@state/helpers";
import VueIconPicker from "@components/vue-icon-picker";

let _ = require("lodash");

export default {
  name: "AppSectionsCreateForm",
  components: { Multiselect, "vue-icon-picker": VueIconPicker },
  props: {
    onformsubmit: {
      type: Function,
      required: true,
    },
    validator: {
      type: Object,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      icon: "",
      appSectionsOptions: [],
      appSectionsOptionsCache: [],
      appSectionsOptionsMounted: false,
      loadingAppSectionsOptions: false,
      iconLabel: this.$t("sectionsSection.icon"),
    };
  },
  watch: {},
  mounted() {
    this.populateAppSectionsOptions();
  },
  methods: {
    ...appSectionsMethods,
    populateAppSectionsOptions(searchQuery) {
      let context = this;
      context.loadingAppSectionsOptions = true;
      let reqParams = context.$select_params(searchQuery);
      const promise = context.fetchAppSections(reqParams);
      return promise
        .then((data) => {
          let listOptions = [];
          data.results.forEach((opt) => {
            // let parentTreeName = ''
            // if (opt.parent_tree.length - 1){
            //     for (let i = 0; i < opt.parent_tree.length; i++) {
            //         if(i !== (opt.parent_tree.length - 1)){
            //             const el = opt.parent_tree[i];
            //             parentTreeName = parentTreeName.concat(`${context.$t('pages.'+el.name)} > `)
            //         }
            //     }
            // }
            // parentTreeName = parentTreeName.concat(context.$t('pages.'+opt.name))
            listOptions.push({
              _id: opt._id,
              name: opt.name,
            });
          });
          context.appSectionsOptions = listOptions;
          context.appSectionsOptionsMounted = true;
          context.loadingAppSectionsOptions = false;
        })
        .catch((error) => {
          context.$axios_error_noty(error, context);
          context.appSectionsOptionsMounted = true;
          context.loadingAppSectionsOptions = false;
        });
    },
    asyncFindAppSections: _.debounce(function (searchQuery) {
      this.populateAppSectionsOptions(searchQuery);
    }, 600),

    labelOfAppSectionsOptions(opt) {
      console.log(opt);
      let appSectionsOptionsFounded = this.appSectionsOptions.find((x) => x._id === opt);
      if (!appSectionsOptionsFounded) {
        let cacheFounded = this.appSectionsOptionsCache.find((x) => x._id === opt);
        console.log(cacheFounded);
        return cacheFounded
          ? cacheFounded
          : this.appSectionsOptionsMounted
          ? `Not found in options: ${opt}`
          : "";
      } else {
        if (this.form.parent === opt) {
          // === When is a single option select
          if (!this.appSectionsOptionsCache.find((x) => x._id === opt)) {
            this.appSectionsOptionsCache.push(appSectionsOptionsFounded);
          }
        }
        return appSectionsOptionsFounded.name;
      }
    },
  },
};
</script>
<template>
  <b-form id="form" @submit="onformsubmit">
    <form-wrapper :validator="validator">
      <div>
        <form-summary />
      </div>
      <form-group name="name" :label="$t('sectionsSection.name')">
        <b-form-input
          v-model="form.name"
          slot-scope="{ attrs, listeners }"
          v-bind="attrs"
          v-on="listeners"
        />
      </form-group>
      <form-group name="path" :label="$t('sectionsSection.path')">
        <b-form-input
          v-model="form.path"
          slot-scope="{ attrs, listeners }"
          v-bind="attrs"
          v-on="listeners"
        />
      </form-group>
      <form-group name="hover_text" :label="$t('sectionsSection.hover_text')">
        <b-form-input
          v-model="form.hover_text"
          slot-scope="{ attrs, listeners }"
          v-bind="attrs"
          v-on="listeners"
        />
      </form-group>
      <vue-icon-picker
        v-model="form.icon_name"
        :form-field="form.icon_name"
        input-name="icon_name"
        :label="iconLabel"
      />
      <form-group
        name="app-sections-select"
        :label="$t('sectionsSection.submenu_of') + '?'"
      >
        <Multiselect
          id="app-sections-select"
          v-model="form.parent"
          :multiple="false"
          :options="appSectionsOptions.map((x) => x._id)"
          :custom-label="(opt) => labelOfAppSectionsOptions(opt)"
          :loading="loadingAppSectionsOptions"
          :internal-search="false"
          @search-change="asyncFindAppSections"
          :select-label="$t('multiselect.select')"
          :selected-label="$t('multiselect.selected')"
          :deselect-label="$t('multiselect.deselect')"
          :placeholder="$t('multiselect.placeholder')"
        >
          <span slot="noOptions">{{ $t("multiselect.no_options") }}</span>
        </Multiselect>
      </form-group>
      <b-row>
        <b-col>
          <form-group>
            <b-form-checkbox
              v-model="form.app_permission"
              :value="true"
              :unchecked-value="false"
            >
              {{ $t("sectionsSection.app_permission") }}?
            </b-form-checkbox>
          </form-group>
        </b-col>
        <b-col v-if="form.app_permission_detail">
          <b-card no-body tag="article" class="mb-0">
            <b-card-body class="pt-0">
              <b-card-title>{{ $t("permissionsSection.permissions") }}</b-card-title>
              <b-card-text>
                <b>{{ $t("permissionsSection.name") }}:</b>
                {{ form.app_permission_detail.name }} <br />
                <b>{{ $t("permissionsSection.codename") }}:</b>
                {{ form.app_permission_detail.codename }} <br />
              </b-card-text>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <!-- <form-group>
            <b-form-checkbox
                v-model="form.admin_required"
                :value="true"
                :unchecked-value="false"
            >
            {{$t('sectionsSection.require-admin')}}?
            </b-form-checkbox>
        </form-group> -->
    </form-wrapper>
  </b-form>
</template>
